<template>
  <div class="vx-card">
    <div class="vx-row p-10 pb-5">
      <div class="vx-col w-full">
        <div class="vx-row">
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-1 mt-1">
            <vs-input
              class="inputx"
              v-model="gridSearchData.name"
              :label="$t('Name')"
              @keyup.enter="submitFilter()"
              v-trim-space
              placeholder="نام "
            />
          </div>
          <div class="vx-col sm:w-2/2 pt-6">
            <div>
              <vs-button
                type="filled"
                class="float-right mx-5"
                @click.prevent="submitFilter()"
                >{{ $t("SubmitFilter") }}</vs-button
              >
              <vs-button
                type="filled"
                class="float-right mr-4"
                id="reset-btn"
                @click.prevent="resetForm"
                >{{ $t("ResetFilter") }}</vs-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card__body card-body">
      <div class="vx-row">
        <!-- <modify-popup
          :show="ModifyPopup"
          :model="modalModel"
          :costTitle="allCostTitle"
          :asignCostTitle="partyCostTitle"
          @finish="onfinish"
          @close="closeModifyPopup"
        >
        </modify-popup> -->

        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('Name'), sort: 'Name' },
              { title: $t('Action'), sort: 'Action' },
            ]"
          >
            <template slot-scope="{ row }">
              <td>
                {{ row.name }}
              </td>

              <td style="direction: ltr">
                <router-link
                  :to="{
                    path: 'addCostTitle' + '/' + row.id,
                    query: {
                      breadcrumbNameManual: {
                        persianTitleParent: row.name,
                      },
                    },
                  }"
                >
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="view-btn"
                    >{{ $t("CostTitle") }}</vs-button
                  >
                </router-link>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./CreatePartyAccount.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      ModifyPopup: false,
      itemList: [],
      allCostTitle: [],
      partyCostTitle: [],
      modalModel: {},
      parentType: 0,
      gridDataSource: { type: "app", service: "/Credits/api/PartiesQuery" },
      gridSearchData: {
        name: "",
      },
    };
  },
  mounted() {
    this.fetchAllCostTitle();

    this.gridDataSource = {
      type: "app",
      service: "/Credits/api/PartiesQuery",
    };
  },
  methods: {
    ...mapActions({
      fetchAllCostTitleByParent: "costCenter/fetchAllCostTitleByParent",
      fetchCostTitle: "pettyCash/fetchCostTitle",
    }),
    fetchCostTitleByParent(id) {
      this.fetchAllCostTitleByParent(id).then((result) => {
        this.partyCostTitle = result;
      });
    },
    fetchAllCostTitle() {
      this.fetchCostTitle().then((result) => {
        result.forEach((element) => {
          var x = {
            name: `${element.name} (${element.id})`,
            id: element.id,
          };

          this.allCostTitle.push(x);
        });
      });
    },
    showAccounts() {
      this.$router.push({ path: "/PettyCash/Accounts" });
    },
    createAccount(accountsInfo) {
      this.ModifyPopup = true;
      this.fetchCostTitleByParent(accountsInfo.id);
      this.modalModel = accountsInfo;
      this.ModifyPopupflag = true;
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 200);
    },
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        name: "",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>

<style scoped></style>
